import { client } from "../../../Infrastructure/agent";
export const MaterialService = {
  loadAssetChemical: (assetId) =>
    client.post("/material/loadAssetChemicals", { assetId }),
  upsertChemical: (chemical, uploadedBy) =>
    client.post("/material/upsertchemical", {
      chemical: { ...chemical, uploadedBy },
    }),
  restock: (formData, newstock) => {
    return client.post("/material/restock", { formData, newstock });
  },
  loadStockHistory: (assetId, chemicalId) =>
    client.post("/material/getstockhistory", { assetId, chemicalId }),

  filterStockHistory: (assetId, chemicalId, startDate, endDate) =>
    client.post("/material/GetStockHistoryBydDate", {
      assetId,
      chemicalId,
      startDate,
      endDate,
    }),
  downloadTemplate: (assetName, assetId) =>
    client.getFile(
      `/material/downloadtemplate?asset=${assetName}&assetId=${assetId}`
    ),
  saveConsumptions: (consumptions) =>
    client.post("/material/SaveConsumptions", { consumptions }),

  loadConsumptions: (query, assetId) =>
    client.post("/material/loadMaterialConsumptions", {
      query,
      assetId,
    }),
};

